import axios from 'axios';

export const adapter = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en',
  },
  baseURL: window.location.origin,
});
